import { render, staticRenderFns } from "./about04.vue?vue&type=template&id=19672df2&scoped=true"
import script from "./about04.vue?vue&type=script&lang=js"
export * from "./about04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19672df2",
  null
  
)

export default component.exports